'use client';

var EDatePicker;
(function (EDatePicker) {
    EDatePicker["date"] = "date";
    EDatePicker["month"] = "month";
    EDatePicker["year"] = "year";
})(EDatePicker || (EDatePicker = {}));

export { EDatePicker };
//# sourceMappingURL=type.js.map
